export const NOTIFICATIONS = "notifications" as const;
export const NOTIFICATION_DETAIL = "notifications-detail" as const;
export const FILTER = "filter" as const;

export type DrawerType =
  | typeof NOTIFICATIONS
  | typeof NOTIFICATION_DETAIL
  | typeof FILTER
  | null;
